define('SC.ContactUsLeadForm.1.0.0.ContactUs', [
    'Backbone',
    'ContactUs.EnableRegistration.View',
    'ContactUs.Router',
    'SC.Configuration',
    'jQuery',
    'underscore',
    'Utils'
], function ContactUs(
    Backbone,
    ContactUsEnableRegistrationView,
    Router,
    Configuration,
    jQuery,
    _
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getComponent('Layout');
            var checkout = application.getComponent('Checkout');
            var config = Configuration.get('contactUs');
            if (config.enableAsRegistration) {
                if (layout) {
                    layout.on('afterShowContent', function afterShowContent() {
                        _.delay(function delayFn() {
                            jQuery('.header-profile-register-link')
                                .attr('data-touchpoint', 'home')
                                .attr('data-hashtag', '#/' + config.urlcomponent)
                                .attr('href', '/' + config.urlcomponent);
                        });
                    });
                }

                if (checkout && layout) {
                    layout.addChildViews(
                        layout.ALL_VIEWS, {
                            'Login': {
                                'Hide.Register': {
                                    childViewIndex: 4,
                                    childViewConstructor: function childViewConstructor() {
                                        return new ContactUsEnableRegistrationView({
                                            application: application,
                                            layout: layout
                                        });
                                    }
                                }
                            }
                        }
                    );


                }
            }

            return new Router(application);
        }
    };
});
